/* istanbul ignore file */
import type { Marker } from 'domain/gpo/cockpit/facade/marker/types';
import { DATE_FORMAT, DEFAULT_TIMEZONE } from 'framework/utils';
import momentTimezone from 'moment-timezone';

class DueDateMarker implements Marker {
  activityId: string;

  html: string;

  position: {
    top: number;
    left: number;
  };

  constructor(activityId: string, value: string) {
    this.activityId = activityId;

    const caption = momentTimezone.utc(value).tz(DEFAULT_TIMEZONE).format(DATE_FORMAT.FULL);

    this.html = `<span class="due-date">${caption}</span>`;
    this.position = {
      left: -47,
      top: -25,
    };
  }
}

export default DueDateMarker;
